import { render, staticRenderFns } from "./LsgModal.vue?vue&type=template&id=a1a5a6e0&"
import script from "./LsgModal.vue?vue&type=script&lang=js&"
export * from "./LsgModal.vue?vue&type=script&lang=js&"
import style0 from "./LsgModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports